import React from "react";
import { duplicateUserRecords } from "./utils";
import { NORECORDS } from "../../Services/CommonLibrary";

export default (({ referralData }) => {
    const duplicateUser = duplicateUserRecords(referralData);
    return <>
        <div class="d-flex justify-content-center">
            <div class="text-center bg-white px-4 py-2 rounded">
                <h3 class="header1 text-capitalize">A single user enrolled in multiple programs. </h3>
            </div>
        </div>
        {
            duplicateUser.data.length != 0 ?
                <table className="table table-bordered  my-6 bg-white shadow table_border remove_strap">
                    <thead className="custom-header" >
                        <tr>
                            <th>Patient</th>
                            <th>Programe</th>
                            <th>Onboarded</th>
                            <th className="break-line">Referred Source (SMS)</th>
                            <th className="break-line">Referred Source (WhatsApp)</th>
                            <th className="break-line">Referred Source (Others)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {duplicateUser?.data.map((group, index) => (
                            // {"areaId":"45","programId":"17","clinicId":"0","name":"Diabetes Improvement","clinicName":"",
                            // "areaName":"Modality Lewisham","userId":"5118569","firstName":"Funmilola Akinsola","lastName":"","cnt":"1",
                            // "onboardedUser":"0","inclinic":"19","is_partial_user":"0","is_sms_user":"0","is_other_user":"0","is_whatsapp_user":"0"}

                            <React.Fragment key={`frag3_${index}`}>
                                {group.map((program, i) => (
                                    <tr key={`key3_${i}`}>
                                        {i === 0 && (
                                            <td rowSpan={group.length}
                                                className="tdRowspan">
                                                <p> {program.firstName}
                                                    {program.lastName}</p>
                                                <div className="rowspan">
                                                    {program.firstName}
                                                    {program.lastName}
                                                </div>
                                            </td>
                                            // <td rowSpan={group.length}>
                                            //     {program.firstName}
                                            //     {program.lastName}
                                            // </td>
                                        )}


                                        <td>{program.name}</td>
                                        <td>{(program.onboardedUser == 1) ? "Y" : "N"}</td>
                                        <td>{(program.is_sms_user == 1) ? "Y" : "N"}</td>
                                        <td>{(program.is_whatsapp_user == 1) ? "Y" : "N"}</td>
                                        <td>{(program.is_other_user == 1) ? "Y" : "N"}</td>
                                    </tr>
                                ))}


                            </React.Fragment>

                            //  <tr key={`key_duplicate_${index}`}>
                            //             <td rowSpan={group.length}>
                            //                 {/* [{"areaId":"45","programId":"17","clinicId":"0","name":"Diabetes Improvement","clinicName":"","areaName":"Modality Lewisham","userId":"5118569","firstName":"Funmilola Akinsola","lastName":"","cnt":"1","onboardedUser":"0","inclinic":"19","is_partial_user":"0","is_sms_user":"0","is_other_user":"0","is_whatsapp_user":"0"},{"areaId":"45","programId":"16","clinicId":"0","name":"Lifestyle Enhancement","clinicName":"","areaName":"Modality Lewisham","userId":"5118569","firstName":"Funmilola Akinsola","lastName":"","cnt":"1","onboardedUser":"0","inclinic":"19","is_partial_user":"0","is_sms_user":"0","is_other_user":"0","is_whatsapp_user":"0"}] */}
                            //                 {group[0].firstName}
                            //                 {group[0].lastName}
                            //             </td>
                            //             {group.map((program, i) => (

                            //                     <td>{program.name}</td>

                            //             ))}
                            //     </tr>
                        ))}
                    </tbody>
                </table>
                : <div className="mb-6"><NORECORDS message="No Duplicate Record Found!" marginTop="10px"/></div>
        }
        {/* {JSON.stringify(duplicateUser)} */}
    </>
})